import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RiskRegisterBulkResultDialogData } from 'src/app/models/risk-register-bulk-update.model';

@Component({
    standalone: false,
    selector: 'app-risk-register-bulk-result-dialog',
    templateUrl: './risk-register-bulk-result-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./risk-register-bulk-result-dialog.component.scss'],
})
export class RiskRegisterBulkResultDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<RiskRegisterBulkResultDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RiskRegisterBulkResultDialogData,
    ) {}

    onClose(): void {
        this.dialogRef.close();
    }
}
